module.exports = __webpack_public_path__ + "img/social-media-display-mazda.e4687c54.png";